import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { Table } from 'react-bootstrap';
import axios from './../../../constants/axios';

class Sale extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         lists: [],
         itemId: null,
      };
   }

   findInvoiceLists = () => {
      axios.get('/findInvoice/getByItemId/' + this.refs.itemId.value)
         .then((res) => {
            this.setState({
               lists: res.data,
            });
         });
   };

   render() {
      const linkConverter = (list) => {
         if (list.transaction_purpose_id === 2) {
            // purchase
            return <Link to={`/purchase/purchaseInvoiceDetail/${list.id}`} target="_blank" >{list.id}</Link >;
         }
         if (list.transaction_purpose_id === 4) {
            // sale
            return <Link to={`/sale/saleInvoiceDetail/${list.id}`} target="_blank" >{list.id}</Link >;
         }
         return list.id;
      };

      const { lists } = this.state;
      return (
         <div className="FindInvoice" >
            <h3 >Find Invoice By Item Id</h3 >
            <hr />
            Item Id: <input ref="itemId" placeholder="Enter Item Id" type="number"
                            name="itemId" />
            <button onClick={this.findInvoiceLists} >Find</button >
            <hr />
            <Table >
               <thead >
               <tr >
                  <th >Id</th >
                  <th >Type</th >
                  <th >Contact Name</th >
                  <th >Unit</th >
                  <th >Price</th >
                  <th >Dis</th >
                  <th >Created</th >
               </tr >
               </thead >
               <tbody >
               {lists.map((list) =>
                  <tr key={list.id} >
                     <td >{linkConverter(list)}</td >
                     <td >{list.transaction_purposes_name}</td >
                     <td >{list.contact_name}</td >
                     <td >{list.unit}</td >
                     <td >{list.price}</td >
                     <td >{list.unit_discount}</td >
                     <td >{list.created_at}</td >
                  </tr >
               )}
               </tbody >
            </Table >
         </div >
      );
   }
}

Sale.propTypes = {
   children: PropTypes.object
};

export default Sale;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FindInvoice/FindInvoice.js
 **/